export const PROFILE_TRAINING_ERROR = 'PROFILE_TRAINING_ERROR';
export const PROFILE_TRAINING_LOADING = 'PROFILE_TRAINING_LOADING';
export const PROFILE_TRAINING_SUCCESS = 'PROFILE_TRAINING_SUCCESS';